// removed by extract-text-webpack-plugin
module.exports = {"Modal":"src-components-Promo-__PromoNotifModal-module___Modal"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Promo/PromoNotifModal.module.css
// module id = 1233
// module chunks = 1